import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { COMPANY, LOGO_URL } from "@/lib/api";

const links = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/commercial", label: "Commercial" },
  { to: "/team", label: "Team" },
  { to: "/careers", label: "Careers" },
  { to: "/book", label: "Book" },
  { to: "/track", label: "Track" },
  { to: "/portal", label: "Client Portal" },
  { to: "/quote", label: "Get a Quote" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  return (
    <header
      data-testid="site-navbar"
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-white/70 border-b border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3 group">
          <img
            src={LOGO_URL}
            alt="Laronta Pro Logistic LLC"
            className="h-10 w-10 rounded-full object-cover ring-1 ring-zinc-800 group-hover:ring-primary-brand transition-all"
          />
          <div className="leading-tight hidden sm:block">
            <div className="font-heading font-black tracking-tight text-slate-900 text-sm">LARONTA PRO</div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500">Logistic LLC</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `px-4 py-2 text-sm uppercase tracking-wider font-medium transition-colors ${
                  isActive ? "text-primary-brand" : "text-slate-700 hover:text-slate-900"
                }`
              }
              end={l.to === "/"}
            >
              {l.label}
            </NavLink>
          ))}
          <a
            href={`tel:${COMPANY.phoneRaw}`}
            data-testid="nav-phone-cta"
            className="ml-4 px-4 py-2 border border-primary-brand text-primary-brand hover:bg-primary-brand hover:text-white text-sm uppercase tracking-wider font-bold transition-colors"
          >
            {COMPANY.phone}
          </a>
        </nav>

        <button
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden text-slate-900 p-2"
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-slate-200 bg-white/95 backdrop-blur-xl">
          <div className="px-6 py-4 flex flex-col gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `px-3 py-3 text-sm uppercase tracking-wider font-medium border-b border-slate-200 ${
                    isActive ? "text-primary-brand" : "text-slate-700"
                  }`
                }
                end={l.to === "/"}
              >
                {l.label}
              </NavLink>
            ))}
            <a
              href={`tel:${COMPANY.phoneRaw}`}
              className="mt-3 px-4 py-3 bg-primary-brand text-white text-center text-sm uppercase tracking-wider font-bold"
            >
              Call {COMPANY.phone}
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
